import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=4c2c41d9&scoped=true&"
import script from "./Table.vue?vue&type=script&lang=js&"
export * from "./Table.vue?vue&type=script&lang=js&"
import style0 from "./Table.vue?vue&type=style&index=0&id=4c2c41d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2c41d9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductLink: require('/usr/src/motec/components/product/Link.vue').default,ProductAttributeValueBoolean: require('/usr/src/motec/components/product/AttributeValue/Boolean.vue').default,ProductAttributeValueTernary: require('/usr/src/motec/components/product/AttributeValue/Ternary.vue').default,ProductAttributeValueBooleanSubtext: require('/usr/src/motec/components/product/AttributeValue/BooleanSubtext.vue').default,ProductAttributeValueHTML: require('/usr/src/motec/components/product/AttributeValue/HTML.vue').default})
